
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faq_458FWEBaV117MUMsnULY_Mfdfmz6rn5TMp_456AWllfqawMeta } from "/codebuild/output/src4246591502/src/src/pages/faq.vue?macro=true";
import { default as menuJzCgboaZ3bhOAnlJ_45LxD5VtxCNsL7xja_45knVigav2hcMeta } from "/codebuild/output/src4246591502/src/src/pages/menu.vue?macro=true";
import { default as indexGhECaAP14p4bveq7zmP9LjHjQXvf3QT4Gm_45v9ErD084Meta } from "/codebuild/output/src4246591502/src/src/pages/index.vue?macro=true";
import { default as contactEYOpKzx_451vEAPo7M609RB1nwjhcGkTHdqKe0PcTdb3kMeta } from "/codebuild/output/src4246591502/src/src/pages/contact.vue?macro=true";
import { default as tutorialKyy4t4mbV0PQI5Q4pqX3wKIW6cHxSK21L_45nUUKs5i8wMeta } from "/codebuild/output/src4246591502/src/src/pages/tutorial.vue?macro=true";
import { default as agreementwndqObohJdrltqJZJ4ojhacys4Ty90uI0q86BqOuHJ8Meta } from "/codebuild/output/src4246591502/src/src/pages/agreement.vue?macro=true";
import { default as about_45passSzHsa9ruoP4yYbvuRLaVYzuqQz_viz3zMke_45_457GTRgMMeta } from "/codebuild/output/src4246591502/src/src/pages/about-pass.vue?macro=true";
import { default as indexohLkkNObYQorv78pGuaqCI0xj_45D13TpNGOEI3Rd_45vJUMeta } from "/codebuild/output/src4246591502/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93JdAq_45osANhvHUMBRFf0Y4F3_o8Rifb_456xY6FQms761cMeta } from "/codebuild/output/src4246591502/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancedOjS_855VSdZGJ8pBEtXXiaw0X3nDuJ8w3nLNNSCmhMMeta } from "/codebuild/output/src4246591502/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93u9gG7x5affAJbzYcY51n1xfj8wImY1Vyuga6N5vuFIYMeta } from "/codebuild/output/src4246591502/src/src/pages/notice/[id].vue?macro=true";
import { default as indexteFKVSL8JRrFaebEnqHnhhT_o8bsUk5EpiV3YYWJwFkMeta } from "/codebuild/output/src4246591502/src/src/pages/coupon/index.vue?macro=true";
import { default as indexgMb0hPYIG4_sthNFD8y7XZDjuLV0B8afPXf9_45c4hxh4Meta } from "/codebuild/output/src4246591502/src/src/pages/mypage/index.vue?macro=true";
import { default as indexLKOmGEWsE5SVnklQ5nO4xF3lv9ZaMYa9SchnB49YGdcMeta } from "/codebuild/output/src4246591502/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93KnuwXOqNF6CjInLuBpXUXKN43yrRjSCbTQVcLnX_d3UMeta } from "/codebuild/output/src4246591502/src/src/pages/parking/[id].vue?macro=true";
import { default as indexQQdDsFhLc0yETwS4HsmtSN5DdjJ8BmHl9XJPU9BiaFIMeta } from "/codebuild/output/src4246591502/src/src/pages/history/index.vue?macro=true";
import { default as indexCBf5ilF1RvL6B8yv_978YNOF0z2jVrwoB_45L7TzMlyEEMeta } from "/codebuild/output/src4246591502/src/src/pages/monthly/index.vue?macro=true";
import { default as index5ehjpjt6WURSRLmwdcy1jMQygL4f7_45q39_yWhyPI0pgMeta } from "/codebuild/output/src4246591502/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexQwS0fO1TupqtZdfMwcXV0yNzVlLOlzZ2FIf1su9P0XMMeta } from "/codebuild/output/src4246591502/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavi3zH8RgxVxIQFCIQUpZZ77bfuU9uvkxFUnLVA9eFZ13IMeta } from "/codebuild/output/src4246591502/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editZl0exOZiUcwcIHfIQNV0KJMVtbYQchoIMOraHvMAWvkMeta } from "/codebuild/output/src4246591502/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementqZckFFD8G_455tWXC1piAG71ClVOpxyhc4dk1XHnaWOH0Meta } from "/codebuild/output/src4246591502/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexd4_45lvI3W_45O3iIxIdjj0uFivOaxhseZtN8bZBYvVuwZ0Meta } from "/codebuild/output/src4246591502/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dR_45L86W5hjog_a1zINPwGJc8p2d54LF0Ig1X2l4wwzdIMeta } from "/codebuild/output/src4246591502/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmLLPnyzBHCuMKDuZ2adM_453nKhljUV__45TC7Aaqh5GzBdQMeta } from "/codebuild/output/src4246591502/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as index0zlq7eNityRBsKv_PzShjxL6ndo9RmEIiwXLPtgIRwYMeta } from "/codebuild/output/src4246591502/src/src/pages/card/create/index.vue?macro=true";
import { default as indexN3WMtsQdsWvig3iF6MJwd0gbC2aQDA346wZz2shMG4YMeta } from "/codebuild/output/src4246591502/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmK9pwMoGHt_45GKVS5kRjXx_AiTiVFS3ZLdSDKxAn9M4QwMeta } from "/codebuild/output/src4246591502/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmi6IV6W02t9IjwRAENUw5vGeTvgfWsRCQaPfQLb79ij4Meta } from "/codebuild/output/src4246591502/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completex7yF_45Dzfg3ULFtGZ2ZwmfyyBsGdOoecs8bBFB0348ocMeta } from "/codebuild/output/src4246591502/src/src/pages/membership/complete.vue?macro=true";
import { default as registerhf3R5S3XHqCAWa_7GCJ5n5f1YqGqMoP5QnNiSwpG_PMMeta } from "/codebuild/output/src4246591502/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93iPkZwUJShw8b_tW6LfdFQuULkZxsRS8NQBMgcGfjaZcMeta } from "/codebuild/output/src4246591502/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmxaORKcFS2tV3XRaYlSUyuVUHZfe59Wkd8HjuAe5dTbUMeta } from "/codebuild/output/src4246591502/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_9315ZTQI5gv3IGOqOzEhjPpqnHrISZeqcmo7jitEo5UK4Meta } from "/codebuild/output/src4246591502/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexeretO6MxCgnjmRkegto8KjHNgpsT3RI8Z1XALyBrLzYMeta } from "/codebuild/output/src4246591502/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeuu6MNtpsiHZiz3Y__o4B43_45C4PrBdXdSZBfYYxUj_IkMeta } from "/codebuild/output/src4246591502/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeyuHCmIQQ8kHj0H_u9rQ66cuMzTsKWX2Doptl0eaY_45CEMeta } from "/codebuild/output/src4246591502/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeeWnM2Y1oxQFHqTkeLr9iYgbcjDjGak4U2naTuAAoTCoMeta } from "/codebuild/output/src4246591502/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerxGDGRXy5PWaKJIOWFOrjy0AXsQyUmepXqOw8kDJox4UMeta } from "/codebuild/output/src4246591502/src/src/pages/contact-form/register.vue?macro=true";
import { default as completepLJEwSzwIUw9mxf9bZERl00JmFBBML2vcj0dGZ21tmwMeta } from "/codebuild/output/src4246591502/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexTuKwDcUJTCmdpD5qrr3X6HQhYKejkzJ7NwnrM4i_45NBwMeta } from "/codebuild/output/src4246591502/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmHoLVQpJWfQOipxWPrsoNmmdTlvI0U1fxDSLwoKO4po8Meta } from "/codebuild/output/src4246591502/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as complete445KFLqrW0PWJhg_45Ss8i_tK7sUu921b_BQBsFbw25SoMeta } from "/codebuild/output/src4246591502/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexybsvOVe4PPolq0mOvlC26EkE4uucic_45KDf7JHZ23fcYMeta } from "/codebuild/output/src4246591502/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93aRXkxPWOuqQU16w53PPZ2EdkHmc6MZi8RpFN7Zk7HQ8Meta } from "/codebuild/output/src4246591502/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeXl0P_eaVN8ASFXz7ZvePNj5zpEpcEva8oRfg8tgY_bIMeta } from "/codebuild/output/src4246591502/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliaslJyD08iDb3uL4kl6PhpnShFLnJsGrKGKtQkAxqsSBbQMeta } from "/codebuild/output/src4246591502/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampledT0ADrHIahW_ejTIxIQprAuZKVGfCtjItvKIQ9m58YoMeta } from "/codebuild/output/src4246591502/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailnFFaTxR_vPDu9_yKNjgbjl75hnA_452uIImWQn_JOsQ9YMeta } from "/codebuild/output/src4246591502/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmCOMgnw7wsYhsHU_J1pKlZdl_45q0_45KzDrkGcsy_45KUHDs8Meta } from "/codebuild/output/src4246591502/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentZ6VIsZUEyNBd90S4wugf3yV5BMb8bnatqph2Aire4ccMeta } from "/codebuild/output/src4246591502/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmSehcLf8357O8fT0qwOttWkilhQhV7R8rk6SLOlgbaxoMeta } from "/codebuild/output/src4246591502/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedate4MdcdW6z8Et_45ko4u5FhI7wHWZa8qDV4R8VwyzOce_45TAMeta } from "/codebuild/output/src4246591502/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as complete27l28FrzpYXUlY1x52vcvqd9aEXcTAe1XiacPcvK8IUMeta } from "/codebuild/output/src4246591502/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeWIYrXQ16tS70Qtrem4NvL9hco0rrhyWr8zW6jdh3ycoMeta } from "/codebuild/output/src4246591502/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45password33SZtSdONYrA9XgLplIlNQGpZLlaEWoqYkoO3TRLNRkMeta } from "/codebuild/output/src4246591502/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasYuxWmSLQuuN6OdePq1tObdSYCBjSi3Q_45zVbuUn_45V0YkMeta } from "/codebuild/output/src4246591502/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerqLyqfcdQPnvQTw6tM_wz0W6vaKsiJxklGHjhAxPg5h0Meta } from "/codebuild/output/src4246591502/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codezDfpN6Un_gdrrcVGjihmyQijfOBLngHWBrJtzYFEiW0Meta } from "/codebuild/output/src4246591502/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexekXNp2LVS_45AMco0nO7m_45RfuL0wxP_45VXwQinCdMP7RywMeta } from "/codebuild/output/src4246591502/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexll2MsOj4xOyDjhvWpPV7fWZHKrPrVwmoPVt8s3pn5fAMeta } from "/codebuild/output/src4246591502/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexQGtw_45NlHDjkUgL9m_hSlbbqBB8YUf_H4HA9I3KYUgDsMeta } from "/codebuild/output/src4246591502/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexEekOcyevEXykes1MSPKM8CJVGUak9FKenZ_45yp7JI8bMMeta } from "/codebuild/output/src4246591502/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updatel7JbGxJpCwPgANR2Vl1LlJt6fIJEQ8qxSSV3I7od4LIMeta } from "/codebuild/output/src4246591502/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completevcVbX812xD_9EYk49B_a_Ogt8CTAYAPWoWaH75EmOBsMeta } from "/codebuild/output/src4246591502/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmotFD_45Z5TZFSp1A0a0r_45rqH__D9x13pUom0_45Xaj0GifAMeta } from "/codebuild/output/src4246591502/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexTOH5YbzPqxRq_AaNT8VRJ1ftfc7EDwOHn59nszB4_LAMeta } from "/codebuild/output/src4246591502/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeScsYWtL_h0PqTj6P_UOLOZyACZHYs_4m1lIeO3x7Sz0Meta } from "/codebuild/output/src4246591502/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as update039LSYLVGb7QnpWsVv4saimNuTsO7dJF2tohNUXyJqMMeta } from "/codebuild/output/src4246591502/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as index0yVCSRcalm4KK2KWdwxkdbmYD00h1c9z0VG3qE7LZYAMeta } from "/codebuild/output/src4246591502/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexs83Qv2JBwmv1u7K5HaU0uMJk095zMZWJ88uZHUL_45pAgMeta } from "/codebuild/output/src4246591502/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as complete32mm7mfBfANjhFDPLjrk31ssxsXvxE4USrWgDbqCg_UMeta } from "/codebuild/output/src4246591502/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexOahTbY4UmZ_kIdbb_JHPLyeC5iopZ7vBW_NkrucdfcwMeta } from "/codebuild/output/src4246591502/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeIxi5AgXIiXbvFnzFC0ENVYw02i_45UkqHV_Aqy17eNrQsMeta } from "/codebuild/output/src4246591502/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as index6qYLbl9iS__45CU5h_0mp0b_45S4rSCYWGAfTwC78nXpCagMeta } from "/codebuild/output/src4246591502/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as index9pFf7UhpcJC2657rO803JHDcNcPADxuUGtKfnXrY2HkMeta } from "/codebuild/output/src4246591502/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexj9kBUrUlKkq6T4_45WE18OJkpCJvktWKKI8E0HEP4P0fsMeta } from "/codebuild/output/src4246591502/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as update2sIjE34_45LlWZ_45p5P_453Bnxppd42IC08qG8ue5EW6DWjoMeta } from "/codebuild/output/src4246591502/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmO_Lbf5LTmYnJu3UV_yMIbueJxb2P767WNszpnxXDMskMeta } from "/codebuild/output/src4246591502/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuJzCgboaZ3bhOAnlJ_45LxD5VtxCNsL7xja_45knVigav2hcMeta || {},
    component: () => import("/codebuild/output/src4246591502/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexGhECaAP14p4bveq7zmP9LjHjQXvf3QT4Gm_45v9ErD084Meta || {},
    component: () => import("/codebuild/output/src4246591502/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexteFKVSL8JRrFaebEnqHnhhT_o8bsUk5EpiV3YYWJwFkMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src4246591502/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src4246591502/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src4246591502/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src4246591502/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexQQdDsFhLc0yETwS4HsmtSN5DdjJ8BmHl9XJPU9BiaFIMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src4246591502/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: index5ehjpjt6WURSRLmwdcy1jMQygL4f7_45q39_yWhyPI0pgMeta || {},
    component: () => import("/codebuild/output/src4246591502/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexQwS0fO1TupqtZdfMwcXV0yNzVlLOlzZ2FIf1su9P0XMMeta || {},
    component: () => import("/codebuild/output/src4246591502/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4246591502/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4246591502/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: index0zlq7eNityRBsKv_PzShjxL6ndo9RmEIiwXLPtgIRwYMeta || {},
    component: () => import("/codebuild/output/src4246591502/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src4246591502/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmK9pwMoGHt_45GKVS5kRjXx_AiTiVFS3ZLdSDKxAn9M4QwMeta || {},
    component: () => import("/codebuild/output/src4246591502/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmi6IV6W02t9IjwRAENUw5vGeTvgfWsRCQaPfQLb79ij4Meta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src4246591502/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completex7yF_45Dzfg3ULFtGZ2ZwmfyyBsGdOoecs8bBFB0348ocMeta || {},
    component: () => import("/codebuild/output/src4246591502/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerhf3R5S3XHqCAWa_7GCJ5n5f1YqGqMoP5QnNiSwpG_PMMeta || {},
    component: () => import("/codebuild/output/src4246591502/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmxaORKcFS2tV3XRaYlSUyuVUHZfe59Wkd8HjuAe5dTbUMeta || {},
    component: () => import("/codebuild/output/src4246591502/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeuu6MNtpsiHZiz3Y__o4B43_45C4PrBdXdSZBfYYxUj_IkMeta || {},
    component: () => import("/codebuild/output/src4246591502/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeyuHCmIQQ8kHj0H_u9rQ66cuMzTsKWX2Doptl0eaY_45CEMeta || {},
    component: () => import("/codebuild/output/src4246591502/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeeWnM2Y1oxQFHqTkeLr9iYgbcjDjGak4U2naTuAAoTCoMeta || {},
    component: () => import("/codebuild/output/src4246591502/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerxGDGRXy5PWaKJIOWFOrjy0AXsQyUmepXqOw8kDJox4UMeta || {},
    component: () => import("/codebuild/output/src4246591502/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmHoLVQpJWfQOipxWPrsoNmmdTlvI0U1fxDSLwoKO4po8Meta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src4246591502/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: complete445KFLqrW0PWJhg_45Ss8i_tK7sUu921b_BQBsFbw25SoMeta || {},
    component: () => import("/codebuild/output/src4246591502/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexybsvOVe4PPolq0mOvlC26EkE4uucic_45KDf7JHZ23fcYMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src4246591502/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeXl0P_eaVN8ASFXz7ZvePNj5zpEpcEva8oRfg8tgY_bIMeta || {},
    component: () => import("/codebuild/output/src4246591502/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4246591502/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampledT0ADrHIahW_ejTIxIQprAuZKVGfCtjItvKIQ9m58YoMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src4246591502/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailnFFaTxR_vPDu9_yKNjgbjl75hnA_452uIImWQn_JOsQ9YMeta || {},
    component: () => import("/codebuild/output/src4246591502/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmCOMgnw7wsYhsHU_J1pKlZdl_45q0_45KzDrkGcsy_45KUHDs8Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src4246591502/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentZ6VIsZUEyNBd90S4wugf3yV5BMb8bnatqph2Aire4ccMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src4246591502/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmSehcLf8357O8fT0qwOttWkilhQhV7R8rk6SLOlgbaxoMeta || {},
    component: () => import("/codebuild/output/src4246591502/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(complete27l28FrzpYXUlY1x52vcvqd9aEXcTAe1XiacPcvK8IUMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src4246591502/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeWIYrXQ16tS70Qtrem4NvL9hco0rrhyWr8zW6jdh3ycoMeta || {},
    component: () => import("/codebuild/output/src4246591502/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45password33SZtSdONYrA9XgLplIlNQGpZLlaEWoqYkoO3TRLNRkMeta || {},
    component: () => import("/codebuild/output/src4246591502/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4246591502/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerqLyqfcdQPnvQTw6tM_wz0W6vaKsiJxklGHjhAxPg5h0Meta || {},
    component: () => import("/codebuild/output/src4246591502/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codezDfpN6Un_gdrrcVGjihmyQijfOBLngHWBrJtzYFEiW0Meta || {},
    component: () => import("/codebuild/output/src4246591502/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src4246591502/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]